// extracted by mini-css-extract-plugin
export default {"searchbar":"searchbar__gYPpE"};